import {
    CrmAPI
} from "./base";

export const crmAPI = new CrmAPI();